<!-- セレクトボックスのコンポーネント -->
<script lang="ts" setup>
import { i18n } from '@/i18n';
import { ISelectOption } from '@/coreDomainsModule/table';

// props
const props = withDefaults(
  defineProps<{
    selectedValue: string;
    options: ISelectOption[];
    selectFieldTitle?: string;
    isBorder?: boolean; // 枠線をつけるかどうか
  }>(),
  {
    selectFieldTitle: '',
    isBorder: false,
  }
);

// emits
const emits = defineEmits<{
  (e: 'update:modelValue', value: string): void;
}>();

//変数
const t = i18n.t;
const borderSize: string = props.isBorder ? '2px' : '0px';

//関数
const changeSelectValue = (event) => {
  emits('update:modelValue', (event.target as HTMLSelectElement).value);
};
</script>

<template>
  <div class="select-field">
    <template v-if="selectFieldTitle">
      <label class="select-field_title-label w-full text-center">{{ t(props.selectFieldTitle) }}</label>
    </template>
    <div class="select-field__frame">
      <select
        class="select-field_selection w-full h-full text-center"
        :data-testid="`select-area`"
        :value="props.selectedValue"
        @change="changeSelectValue"
      >
        <option v-for="option in props.options" :key="option.value" :value="option.value">
          {{ t(option.label) }}
        </option>
      </select>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.select-field {
  border-style: solid;
  border-color: $border;
  border-width: v-bind(borderSize);
  flex-direction: column;
  &__frame {
    width: 100%;
    height: 100%;
  }
}
</style>
